module.exports = __webpack_public_path__ + "img/nissan-frontier.c03edaf4.jpg";